export default __webpack_public_path__ + "static/media/Grouport.4c263533.jpg";